module.exports = __webpack_public_path__ + "static/media/Bil.ad195107.PNG";